import { createSlice } from "@reduxjs/toolkit";

const instructionSlice = createSlice({
  name: "instructions",
  initialState: {
    isFetching: false,
    instructions: [],
    error: []
  },
  reducers: {
    statusInstructionStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusInstructionSuccess: (state, action) => {
      state.isFetching = false
      state.instructions = action.payload
      state.error = []
    },
    statusInstructionFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})

export const { 
  statusInstructionStart,
  statusInstructionSuccess,
  statusInstructionFailure 
} = instructionSlice.actions

export default instructionSlice.reducer